<template>
  <div class="invitation_and_exchange-base">
    <div class="tabs">
      <div class="tab-item" :class="{ active: activeTab === EXCHANGE_TAB }" @click="onClickTab(EXCHANGE_TAB)">兑换码</div>
      <!-- <div class="tab-item" :class="{ active: activeTab === INVITATION_TAB }" @click="onClickTab(INVITATION_TAB)">邀请码</div> -->
    </div>
    <!-- 邀请 -->
    <!-- <div class="invitation-bl" v-show="activeTab === INVITATION_TAB">
      <div class="invitation code-ipt-wrap">
        <div class="invitation code-tips">{{ tips }}</div>
        <div class="input-wrap" :class="{ disabled: +vipInfo.status !== 1 }">
          <span class="invitation_code">{{ invitationCode }}</span>
          <span class="btn copy_btn" :class="{ disabled: +vipInfo.status !== 1 }" ref="invitationCode" :data-clipboard-text="`${invitationCode}`">
            点击复制
          </span>
        </div>
      </div>
      <div class="invitation data_list" v-if="invitationList.length">
        <div class="title invitation-numbers">我邀请的用户：{{ invitePaging.total }}</div>
        <div class="invitation_list">
          <div class="invitation-item" v-for="item in invitationList" :key="item.id">
            <div class="left-wrap">
              <span class="mobile">{{ item.mobile }}</span>
              <span class="date">{{ item.created_date }}</span>
            </div>
            <div class="right-wrap">
              <i class="iconfont iconadd"></i>
              {{ item.day }}天
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 邀请END -->
    <!-- 兑换 -->
    <div class="exchange-bl" v-show="activeTab === EXCHANGE_TAB">
      <div class="exchange code-ipt-wrap">
        <div class="exchange code-tips">使用兑换码可以立即获得对应的权益</div>
        <div class="input-wrap">
          <el-input placeholder="请输入兑换码" v-model="exchangeCode"></el-input>
          <span class="btn" @click="exchangeConfirm()">
            确定
          </span>
        </div>
      </div>
      <div class="exchange data_list" v-if="exchangeList.length">
        <div class="title">兑换记录</div>
        <div class="exchange_list">
          <div class="exchange-item" v-for="item in exchangeList" :key="item.id" @click="openExchangeDetail(item.id)">
            <div class="left-wrap">
              <span class="item-title">{{ item.title }}</span>
              <span class="item-content">{{ item.content }}</span>
            </div>
            <div class="right-wrap">
              <i class="iconfont iconarrow_right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 兑换END -->
    <!-- 收货人弹窗 -->
    <el-dialog :visible.sync="addressDialog" class="address-dialog" width="400px" :show-close="false">
      <div class="popup-container">
        <div class="popup-title">兑换该内容需要填写收货人信息</div>
        <div class="consignee-form">
          <div class="consignee-form-item">
            <span class="label">收货人姓名：</span>
            <el-input v-model.trim="consigneeForm.name" placeholder="请输入姓名"></el-input>
          </div>
          <div class="consignee-form-item">
            <span class="label">收货人手机号：</span>
            <el-input
              v-model.trim="consigneeForm.mobile"
              placeholder="请输入手机号"
              @input="consigneeForm.mobile = consigneeForm.mobile.replace(/[^\d]/g, '')"
              @blur="checkMobile"
              maxlength="11"
            ></el-input>
          </div>
          <div class="consignee-form-item region">
            <span class="label">地址：</span>
            <span class="region-wrap">
              <span class="region-text" :class="{ empty: !consigneePopupRegionStr }">{{ consigneePopupRegionStr || '请选择' }}</span>
            </span>
            <el-cascader size="large" :options="regionOptions" v-model.trim="consigneeForm.region"> </el-cascader>
          </div>
          <div class="consignee-form-item">
            <span class="label">详细地址：</span>
            <el-input type="textarea" autosize v-model.trim="consigneeForm.address" placeholder="请输入详细地址"></el-input>
          </div>
        </div>
        <div class="popup-actions-bl">
          <div class="save_btn" :class="{ disabled: disableConsigneeSaveBtn }" @click="consigneeSubmit">确定兑换</div>
        </div>
      </div>
    </el-dialog>
    <!-- 收货人弹窗END -->
    <!-- 兑换结果弹窗 -->
    <el-dialog
      :visible.sync="exchangeResDialog"
      class="exchange_res-dialog"
      width="400px"
      :show-close="false"
      center
      :before-close="exchangeDialogClose"
    >
      <div class="exchange_res-dialog-title" slot="title">
        <img :src="require(`@/assets/imgs/icon/pay_success.png`)" v-if="!exchangeData.isDetail" />
        {{ exchangeData.isDetail ? '兑换详情' : '兑换成功' }}
      </div>
      <div class="dialog-container">
        <div class="row">
          <div class="label">兑换码</div>
          <div class="value">{{ exchangeData.exchange_code }}</div>
        </div>
        <div class="row" v-if="exchangeData.isDetail">
          <div class="label">兑换时间</div>
          <div class="value">{{ exchangeData.exchange_time }}</div>
        </div>
        <div class="exchange_content row">
          <div class="label">兑换内容</div>
          <div class="row-contents">
            <div class="row-content-wrap" v-for="cont in exchangeData.contents" :key="cont.title">
              <div class="content-title">{{ cont.title }}</div>
              <div class="content-extension">
                <span class="content-extension-item point" v-for="item in cont.extension" :key="item">
                  {{ item }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="exchangeData.address && isSelfOrder">
          <div class="label">收货人信息</div>
          <div class="value">{{ exchangeData.name }}</div>
          <div class="value">{{ exchangeData.mobile }}</div>
          <div class="value">{{ exchangeData.address }}</div>
        </div>
        <div class="row" v-if="exchangeData.isDetail && exchangeData.express && exchangeData.express.express_num && isSelfOrder">
          <div class="label">物流信息</div>
          <div class="value">快递公司：{{ exchangeData.express.delivery }}</div>
          <div class="value">快递单号：{{ exchangeData.express.express_num }}</div>
        </div>
      </div>
    </el-dialog>
    <!-- 兑换结果弹窗END -->
    <!-- 兑换课程弹窗 -->
    <el-dialog :visible.sync="exchangeCourseDialog" class="exchange_course-dialog" width="400px" :show-close="false">
      <div class="exchange_course-dialog-title" slot="title">
        选择一门课程兑换即可拥有，不包含课程附带的实物。
      </div>
      <div class="dialog-container">
        <div class="course-list">
          <div class="row" v-for="course in courseList" :key="course.id" @click="handleCourseSel(course.id)">
            <div class="label">
              <div class="name">{{ course.name }}</div>
              <div class="price">售价：{{ course.price }}元</div>
            </div>
            <div class="radio">
              <span class="yixi-checkbox" :class="{ checked: courseSelectedId === course.id }"></span>
            </div>
          </div>
        </div>
        <div class="course-btn" @click="handleExchangeCourse">确 认 兑 换</div>
      </div>
    </el-dialog>
    <!-- 兑换课程弹窗END -->
  </div>
</template>

<script>
import requestApi from '@/service';
import Clipboard from 'clipboard';
const INVITATION_TAB = 1;
const EXCHANGE_TAB = 2;
import { Input, Cascader, Dialog } from 'element-ui';
import { regionData, CodeToText } from 'element-china-area-data';
import { mapState } from 'vuex';

export default {
  components: {
    [Input.name]: Input,
    [Dialog.name]: Dialog,
    [Cascader.name]: Cascader,
  },
  data() {
    const getRegionData = () => {
      const filterData = ['710000', '810000', '820000']; // 不支持邮寄台湾、香港、澳门
      return regionData.filter(item => {
        return !filterData.includes(item.value);
      });
    };
    const regionOptions = getRegionData();
    return {
      INVITATION_TAB,
      EXCHANGE_TAB,
      invitationCode: '', // 邀请码
      exchangeCode: '', // 兑换码
      invitationList: [], // 邀请列表
      exchangeList: [],
      // 邀请与兑换
      activeTab: EXCHANGE_TAB,
      invitePaging: {
        total: 0,
        pageNum: 1,
        pageSize: 5,
      },
      exchangePaging: {
        total: 0,
        pageNum: 1,
        pageSize: 5,
      },
      addressDialog: false, // 地址填写弹框
      regionOptions,
      // 收件信息
      consigneeForm: {
        region: [],
        name: '',
        mobile: '',
        address: '',
      },
      exchangeResDialog: false, // 兑换结果弹窗
      exchangeData: {}, // 兑换弹窗
      // 兑换课程
      exchangeCourseDialog: false,
      courseBtnLoading: true,
      courseList: [], // 课程列表
      courseSelectedId: '', // 已选课程ID
    };
  },
  computed: {
    ...mapState(['vipInfo']),
    tips() {
      return +this.vipInfo.status === 1 ? '邀请人与被邀请人都将获得30天会员有效期' : '加入会员后即可获得邀请码';
    },
    isSelfOrder() {
      return this.exchangeData.exchange_use_user_id === this.exchangeData.exchange_user_id;
    },
    disableConsigneeSaveBtn() {
      let flag = false;
      const keys = Object.keys(this.consigneeForm);
      for (const key of keys) {
        if (!this.consigneeForm[key] || (key === 'region' && !this.consigneeForm[key].length)) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    consigneePopupRegionStr() {
      const region = this.consigneeForm.region;
      const province = CodeToText[region[0]];
      const city = CodeToText[region[1]];
      const district = CodeToText[region[2]];
      return province ? `${province || ''} ${city || ''} ${district || ''}` : '';
    },
    isLoadedAllExchange() {
      return this.exchangePaging.total / this.exchangePaging.pageSize <= this.exchangePaging.pageNum;
    },
    isLoadedAllInvitation() {
      return this.invitePaging.total / this.invitePaging.pageSize <= this.invitePaging.pageNum;
    },
  },
  mounted() {
    this.onClickTab(EXCHANGE_TAB);
    this.initCopy();
  },
  beforeDestroy() {
    // 释放内存
    this.clipboard.destroy();
  },
  methods: {
    initCopy() {
      this.clipboard = new Clipboard(this.$refs.invitationCode);
      this.clipboard.on('success', () => {
        this.$message.success('复制成功');
      });
      this.clipboard.on('error', () => {
        // 不支持复制
        console.error('该浏览器不支持自动复制');
      });
    },
    onClickTab(val) {
      this.activeTab = val;
      if (val === INVITATION_TAB) {
        this.refreshInvitationData();
        if (+this.vipInfo.status === 1) {
          this.getInvitationCode();
        }
      } else {
        this.exchangeCode = '';
        this.refreshExchangeData();
      }
    },
    /**
     * @description: 获取邀请码
     */
    getInvitationCode() {
      requestApi('/v3/api/h5/consume/invitecode/add/', {}, 'POST').then(res => {
        this.invitationCode = res.code;
      });
    },
    refreshInvitationData() {
      this.invitePaging.pageNum = 1;
      this.getInvitationList();
    },
    // 获取邀请列表
    getInvitationList() {
      requestApi('/v3/api/h5/consume/invitecodes/', {
        page: this.invitePaging.pageNum,
        page_size: this.invitePaging.pageSize,
      }).then(res => {
        if (this.invitePaging.pageNum === 1) {
          this.invitationList = res.items;
          this.invitePaging.total = res.total;
        } else {
          this.invitationList.push(...res.items);
        }
      });
    },
    loadMoreInvitation() {
      if (!this.isLoadedAllInvitation) {
        this.invitePaging.pageNum += 1;
        this.getExchangeList();
      }
    },
    refreshExchangeData() {
      this.exchangePaging.pageNum = 1;
      this.getExchangeList();
    },
    // 获取优惠码列表
    getExchangeList() {
      requestApi('/v3/api/h5/consume/exchangecodes/', {
        page: this.exchangePaging.pageNum,
        page_size: this.exchangePaging.pageSize,
      }).then(res => {
        if (this.exchangePaging.pageNum === 1) {
          this.exchangeList = res.items;
          this.invitePaging.total = res.total;
        } else {
          this.exchangeList.push(...res.items);
        }
      });
    },
    loadMoreExchange() {
      if (!this.isLoadedAllExchange) {
        this.exchangePaging.pageNum += 1;
        this.getExchangeList();
      }
    },
    // 确定兑换
    exchangeConfirm(wanxiang_id = null) {
      if (!this.exchangeCode) {
        this.$message.error('请输入兑换码');
        return;
      }
      const address_id = this.consignee && this.consignee.address_id ? this.consignee.address_id : null;
      requestApi(
        '/v3/api/h5/consume/exchange/',
        {
          code: this.exchangeCode,
          address_id,
          wanxiang_id,
        },
        'POST',
        {},
        {
          printMsg: false, // 不打印消息
        }
      )
        .then(
          async res => {
            this.openExchangeDetail(res.id, false);
            this.refreshExchangeData();
            this.exchangeCode = '';
          },
          err => {
            this.handleExchangeCodeError(err);
          }
        )
        .finally(() => {
          if (wanxiang_id) {
            this.exchangeCourseDialog = false;
          }
        });
    },
    handleExchangeCodeError(err) {
      switch (err.error_code) {
        case 1:
          this.$message.error('兑换码有误');
          break;
        case 2:
          this.addressDialog = true;
          break;
        case 3:
          this.$message.error('收货地址与登录用户不匹配');
          this.addressDialog = true;
          break;
        case 4:
          this.$message.error('该兑换码已被使用');
          break;
        case 5: // 获取课程列表（选择兑换课程）
          this.getCourseList();
          break;
        default:
          break;
      }
    },

    // 收件人提交
    async consigneeSubmit() {
      if (this.disableConsigneeSaveBtn || !this.checkMobile()) return;
      const params = this.handleConsigneeParams();
      const data = await requestApi('/v3/api/h5/address/', params, 'PUT');
      this.consigneePopup = false;
      this.consignee = data;
      this.exchangeConfirm(); // 再次发起兑换验证请求
    },
    /**
     * @description: 处理需要提交的收件人参数
     */
    handleConsigneeParams() {
      const { region, mobile, name, address } = this.consigneeForm;
      const params = {
        province: CodeToText[region[0]],
        city: CodeToText[region[1]],
        district: CodeToText[region[2]],
        mobile,
        name,
        address,
      };
      return params;
    },
    // 校验手机号
    checkMobile() {
      const mobile = this.consigneeForm.mobile;
      const res = mobile.length === 11 && /^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(mobile);
      if (!res) {
        this.$message.error('请输入正确的手机号码');
      }
      return res;
    },
    // 兑换详情
    openExchangeDetail(id, isDetail = true) {
      requestApi(`/v3/api/h5/consume/${id}`).then(res => {
        this.exchangeData = res.order;
        this.exchangeData.isDetail = isDetail;
        this.exchangeResDialog = true;
      });
    },
    // 兑换弹框 关闭
    exchangeDialogClose() {
      this.exchangeData = {};
      this.exchangeResDialog = false;
    },
    // 获取课程列表
    getCourseList() {
      requestApi('/v3/api/h5/consume/wanxiang/exchange/').then(data => {
        this.courseList = data;
        this.openCourseDialog();
      });
    },
    // 显示选择课程
    openCourseDialog() {
      this.courseSelectedId = this.$options.data().courseSelectedId;
      this.exchangeCourseDialog = true;
    },
    // 选择课程
    handleCourseSel(id) {
      this.courseSelectedId = id;
    },
    // 兑换课程
    handleExchangeCourse() {
      if (!this.courseSelectedId) {
        this.$message.error('请选择课程');
        return;
      }
      this.exchangeConfirm(this.courseSelectedId);
    },
  },
};
</script>

<style lang="scss" scoped>
.invitation_and_exchange-base {
  min-height: 100%;
  background: $C1;
  padding: 20px 30px;
  box-sizing: border-box;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
  .tabs {
    border-bottom: 1px solid #39394d;
    display: flex;
    padding-bottom: 14px;
    margin-bottom: 20px;
    .tab-item {
      font-size: 18px;
      line-height: 26px;
      margin-right: 20px;
      font-weight: bold;
      cursor: pointer;
      transition: color 0.3s ease-in;
      &.active {
        color: $C7;
      }
    }
  }
  .invitation-bl,
  .exchange-bl {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .code-ipt-wrap {
      width: 400px;
      background: $C15;
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
      display: inline-block;
      padding: 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      .code-tips {
        font-size: 14px;
        line-height: 20px;
        color: $C13;
        margin-bottom: 15px;
      }
      .input-wrap {
        display: flex;
        align-items: center;
        border: 1px solid rgba(194, 201, 215, 0.4);
        font-size: 12px;
        line-height: 18px;
        &.disabled {
          background: $C11;
        }
        .btn {
          padding: 10px 18px;
          background: $C3;
          color: $C1;
          border-radius: 1px;
          box-sizing: border-box;
          cursor: pointer;
          &.disabled {
            background: $C12;
            cursor: default;
          }
        }
      }
    }
    .data_list {
      border: 1px solid rgba(194, 201, 215, 0.4);
      background: $C1;
      width: 400px;
      .title {
        padding: 15px 20px;
        font-size: 14px;
        line-height: 20px;
        color: #808080;
        background: $C15;
      }
    }
  }
  .invitation-bl {
    .input-wrap {
      .invitation_code {
        flex: 1;
        height: 40px;
        display: inline-block;
        padding: 10px 15px;
        width: 270px;
        box-sizing: border-box;
        background: $C1;
        color: $C13;
      }
      &.disabled .invitation_code {
        background: transparent;
      }
    }
    .invitation_list {
      .invitation-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        padding: 10px 20px;
        line-height: 20px;
        .left-wrap {
          display: flex;
          flex-direction: column;
          .date {
            font-size: 12px;
            line-height: 18px;
            color: #bdbdbd;
          }
        }
        .right-wrap {
          .iconfont {
            font-size: 10px;
          }
        }
      }
    }
  }
  .exchange-bl {
    .el-input {
      flex: 1;
      width: auto;
      max-width: calc(100% - 60px);
      ::v-deep.el-input__inner {
        border: none;
        outline: none;
        background: #fff;
        height: 38px;
      }
    }
    .exchange_list {
      .exchange-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        padding: 10px 20px;
        line-height: 20px;
        color: $C3;
        cursor: pointer;
        .left-wrap {
          display: flex;
          flex-direction: column;
          .item-content {
            font-size: 12px;
          }
        }
        .right-wrap {
          .iconfont {
            font-size: 16px;
          }
        }
      }
    }
  }
  .address-dialog {
    ::v-deep.el-dialog__header,
    ::v-deep.el-dialog__body {
      padding: 0;
    }
    .popup-container {
      padding: 0 0 30px;
      width: 100%;
      box-sizing: border-box;
      background: $C15;
      .popup-title {
        padding: 20px 30px 10px;
        text-align: left;
        font-size: 12px;
        line-height: 14px;
        color: #4a4a4a;
        letter-spacing: 1px;
        background: $C15;
      }
      .consignee-form {
        &-item {
          background: $C1;
          display: flex;
          align-items: center;
          margin-bottom: 1px;
          padding: 15px 30px;
          font-size: 14px;
          .label {
            white-space: nowrap;
            color: $C3;
            line-height: 20px;
          }
          ::v-deep.el-input__inner {
            border: none;
            text-align: right;
            color: $C3;
            background: transparent;
          }
          ::v-deep.el-textarea__inner {
            border: none;
            resize: none;
            text-align: right;
          }
          &.region {
            position: relative;
            .region-wrap {
              flex: 1;
              text-align: right;
              display: inline-block;
              height: 100%;
              padding: 0 15px;
              .region-text {
                width: auto;
                display: inline-block;
                text-align: justify;
                &.empty {
                  color: #c1c4cb;
                }
              }
            }
            .el-cascader {
              position: absolute;
              right: 0;
              top: 0;
              width: 70%;
              opacity: 0;
            }
          }
        }
      }
      .popup-actions-bl {
        padding-top: 20px;
        text-align: center;
        .save_btn {
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 7px;
          font-weight: 300;
          color: $C1;
          transition: all 0.3s ease-in-out;
          display: inline-block;
          padding: 10px 40px;
          background: $C7;
          border: 1px solid $C7;
          cursor: pointer;
          &.disabled {
            color: $C13;
            border-color: $C12;
            background: $C1;
          }
        }
      }
    }
  }
  .exchange_res-dialog {
    ::v-deep.el-dialog__header,
    ::v-deep.el-dialog__body {
      padding: 0;
    }
    &-title {
      font-size: 20px;
      line-height: 30px;
      padding: 20px 0;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.6);
      letter-spacing: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        width: 13px;
        height: 17px;
        max-width: 13px;
        margin-right: 10px;
      }
    }
    .dialog-container {
      padding-top: 10px;
      padding-bottom: 20px;
      .row {
        padding: 10px 30px;
        .label {
          font-size: 10px;
          line-height: 14px;
          margin-bottom: 5px;
          color: $C8;
        }
        .value {
          font-size: 14px;
          line-height: 20px;
          color: $C3;
        }
      }
      .row-contents {
        display: flex;
        .row-content-wrap {
          flex: 1;
          color: $C3;
          .content-extension {
            display: flex;
            flex-direction: column;
            font-size: 12px;
            line-height: 16px;
            margin-top: 5px;
          }
        }
      }
    }
  }
  // 兑换课程弹窗
  .exchange_course-dialog {
    ::v-deep.el-dialog__header,
    ::v-deep.el-dialog__body {
      padding: 0;
    }
    &-title {
      font-family: Source Han Sans SC;
      font-size: 10px;
      line-height: 44px;
      color: #808080;
      text-align: left;
      padding-left: 20px;
      background: #fafbfc;
    }
    .dialog-container {
      position: relative;
      .course-list {
        min-height: 200px;
        max-height: 360px;
        overflow: auto;
        padding-bottom: 80px;
        .row {
          display: flex;
          flex-wrap: nowrap;
          padding: 0 20px;
          justify-content: space-between;
          align-items: center;
          min-height: 60px;
          border-bottom: 1px solid #f1f6fc;
          cursor: pointer;
          .label {
            .name {
              font-size: 14px;
              line-height: 20px;
              color: #000000;
            }
            .price {
              font-size: 12px;
              line-height: 17px;
              color: #808080;
            }
          }
        }
      }

      .course-btn {
        position: absolute;
        left: 50%;
        bottom: 20px;
        transform: translateX(-50%);
        background: #ce0900;
        box-shadow: 0px 0px 1px #4d0300;
        border-radius: 2px;
        cursor: pointer;
        width: 157px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        font-size: 14px;
        text-align: center;
        font-weight: bold;
      }
    }

    &.checked {
      color: $C3;
    }
  }
}
</style>
